/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SchedulingStrategyConfig } from './SchedulingStrategyConfig';
import {
    SchedulingStrategyConfigFromJSON,
    SchedulingStrategyConfigFromJSONTyped,
    SchedulingStrategyConfigToJSON,
    SchedulingStrategyConfigToJSONTyped,
} from './SchedulingStrategyConfig';

/**
 * 
 * @export
 * @interface CalendarBasedStrategyConfig
 */
export interface CalendarBasedStrategyConfig extends SchedulingStrategyConfig {
    /**
     * 
     * @type {boolean}
     * @memberof CalendarBasedStrategyConfig
     */
    filterTransparency: boolean;
    /**
     * How many days in advance to generate slots.
     * @type {number}
     * @memberof CalendarBasedStrategyConfig
     */
    advanceBookingDays: number;
    /**
     * The last possible bookable Instant, after this the Meeting is considered expired.
     * @type {Date}
     * @memberof CalendarBasedStrategyConfig
     */
    lastBookableDate?: Date;
}

/**
 * Check if a given object implements the CalendarBasedStrategyConfig interface.
 */
export function instanceOfCalendarBasedStrategyConfig(value: object): value is CalendarBasedStrategyConfig {
    if (!('filterTransparency' in value) || value['filterTransparency'] === undefined) return false;
    if (!('advanceBookingDays' in value) || value['advanceBookingDays'] === undefined) return false;
    return true;
}

export function CalendarBasedStrategyConfigFromJSON(json: any): CalendarBasedStrategyConfig {
    return CalendarBasedStrategyConfigFromJSONTyped(json, false);
}

export function CalendarBasedStrategyConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalendarBasedStrategyConfig {
    if (json == null) {
        return json;
    }
    return {
        ...SchedulingStrategyConfigFromJSONTyped(json, true),
        'filterTransparency': json['filterTransparency'],
        'advanceBookingDays': json['advanceBookingDays'],
        'lastBookableDate': json['lastBookableDate'] == null ? undefined : (new Date(json['lastBookableDate'])),
    };
}

export function CalendarBasedStrategyConfigToJSON(json: any): CalendarBasedStrategyConfig {
    return CalendarBasedStrategyConfigToJSONTyped(json, false);
}

export function CalendarBasedStrategyConfigToJSONTyped(value?: CalendarBasedStrategyConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...SchedulingStrategyConfigToJSONTyped(value, true),
        'filterTransparency': value['filterTransparency'],
        'advanceBookingDays': value['advanceBookingDays'],
        'lastBookableDate': value['lastBookableDate'] == null ? value['lastBookableDate'] : value['lastBookableDate'].toISOString(),
    };
}

